import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {Validators, FormGroup, FormBuilder} from "@angular/forms";
// import {LoginUsecase} from "../../domain/usecases/auth_login.usecase";
// import {GetMaestroUsecase} from "@app/home/domain/usecases/maestro_lista.usecase";
import {UserPass, User, Tabla} from "../../models/login/index";
import {AuthService} from "../../_helpers/auth.service";
import { AuthorizationService } from 'src/app/services/authorization.service';

@Component({
	selector: "app-dashboard",
	templateUrl: "login.component.html"
})
export class LoginComponent implements OnInit {
	loginForm: FormGroup;
	user: UserPass = {usuario: "", password: "", codUsuario: 1, newPassword: ""};
	tablas: Tabla[] = [];
	load: boolean = true;
	constructor(
		public router: Router,
		private fb: FormBuilder,
		private loginUsecase: AuthorizationService,
		private authService: AuthService,
		private getMaestroUsecase: AuthorizationService
	) {}

	ngOnInit() {
		this.loginForm = this.fb.group({
			usuario: ["", Validators.required],
			password: ["", Validators.required]
		});
		this.loginForm.valueChanges.subscribe((data) => {
			this.user.usuario = data.usuario;
			this.user.password = data.password;
		});
	}
	onSubmitLogin() {
		if (this.loginForm.valid && this.load) {
			this.load = false;
			this.loginUsecase.getLogin(this.user).subscribe(
				(login: User) => {
					if(login.codTipoPersona==1)
					{
						this.authService.setData(login);
						this.load = true;
						this.getMaestroUsecase.getMaestro().subscribe((value: Tabla[]) => {
							this.authService.setMaestros(value);
							this.router.navigate(["/Dashboard"]);

						});
					}
					else {
						this.authService.addsmsWarn("No tiene Acceso al sistema");
						this.load = true;
					}
				},
				(error) => {
					console.log(error);
					// if(error.status== 500) this.authService.addsmsError(error.error.error);
					// else this.authService.ErrorServer();
					this.load = true;
				}
			);
			//
		}
	}
}




// import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'app-login',
//   templateUrl: './login.component.html',
//   styleUrls: ['./login.component.scss']
// })
// export class LoginComponent implements OnInit {

//   constructor() { }

//   ngOnInit(): void {
//   }

// }


